module.exports = __webpack_public_path__ + "static/media/stekker.690cdccd.png";